// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"eba59466","239":"aedbdaed","667":"ba818a81","885":"3ab829da"}[chunkId] + ".chunk.js";
};